import './parameters.css';
import { templates } from '../cms-templates/template';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect, useState } from 'react';

async function loadParams(toast, currentPage, setParams, setLoaded) {
    if (!currentPage) {
        setParams([]);
        return;
    }

    toast.info('Loading parameters, input is not editable until loading is complete');

    let buffer = {};
    let loaded = 0;
    let awaiting = 0;
    templates[currentPage.template].forEach(param => {
        buffer[param] = [];
        fetch(`/v1/api/pages/${currentPage.id}/parameters/${param}`)
            .then(resp => resp.json())
            .then(data => {
                setParams({...buffer});
                awaiting += data.range;
                for (let i = 0; i < data.range; i++) {
                    fetch(`/v1/api/pages/${currentPage.id}/parameters/${param}/${i}`)
                        .then(resp => resp.json())
                        .then(paramData => {
                            buffer[param].push({...paramData});
                            // Shallow copy the paramData to generate new ref
                            // and trigger re-render
                            setParams({...buffer});
                        })
                        .catch(_ => toast.error(`Failed to fetch parameter values "${param}"`))
                        .finally(() => {
                            loaded++;
                            if (loaded === awaiting) {
                                Object.keys(buffer).map(key => {
                                    buffer[key].sort((a, b) => a.id - b.id);
                                });
                                setParams(buffer);
                                setLoaded(true);
                                toast.success('Parameters loaded successfully and now editable');
                            }
                        });
                }
            })
            .catch(_ => toast.error('Failed to fetch parameters'))
            .finally(() => {
                if (awaiting === 0) {
                    console.log('No parameters found');
                    setLoaded(true);
                    toast.success('Parameters loaded successfully and now editable');
                }
            });
    });
}

// TODO: Implement an ACID-compliant API endpoint for updating parameters.
async function updateParam(currentPage, fnSetCurrentPage, param) {
    let loaded = 0;
    let awaiting = 0;
    fetch(`/v1/api/pages/${currentPage.id}/parameters/${param}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(async () => {
            const values = document.getElementById(`param-input-${param}`).value.split(' ').filter(Boolean);
            awaiting += values.length;
            for (let i = 0; i < values.length; i++) {
                const assetAlias = values[i];
                let prom = await fetch(`/v1/api/pages/${currentPage.id}/parameters`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        alias: param,
                        'asset-alias': assetAlias.trim(),
                    }),
                });
                if (!prom.ok) {
                    toast.error(`Failed to update parameter "${param}". It has been deleted.`);
                } else {
                    console.log(`Parameter "${param}" updated with asset "${assetAlias}"`);
                    toast.success(`Parameter "${param}" updated successfully`);
                }

                if (loaded === awaiting) {
                    fnSetCurrentPage({ ...currentPage, updated: new Date().toUTCString() });
                }

                // prom.then(resp => resp.ok ? Promise.resolve() : Promise.reject())
                //     .then(() => {
                //         console.log(`Parameter "${param}" updated with asset "${assetAlias}"`);
                //         toast.success(`Parameter "${param}" updated successfully`);
                //     })
                //     .catch(() => {
                //         toast.error(`Failed to update parameter "${param}". It has been deleted.`);
                //     }).finally(() => {
                //         loaded++;
                //         if (loaded === awaiting) {
                //             fnSetCurrentPage({ ...currentPage, updated: new Date().toUTCString() });
                //         }
                //     });
            };
        })
        .catch(() => {
            toast.error(`Failed to update parameter "${param}"`);
        })
        .finally(() => {
            if (awaiting === 0) {
                toast.success(`Parameter cleared successfully`);
            }
        });
}

export default function Params({ currentPage, fnSetCurrentPage }) {
    const [params, setParams] = useState(null);
    const [table, setTable] = useState({});
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        loadParams(toast, currentPage, setParams, setLoaded);
    }, [currentPage]);

    useEffect(() => {
        if (!params) return;

        let table = {};
        Object.keys(params).forEach(param => {
            table[param] = params[param].map(asset => asset.alias).join(' ');
        });
        setTable(table);
    }, [params]);

   return <div className='params'>
        <table>
            <thead>
                <tr hidden>
                    <th>Parameter Name</th>
                    <th>Values</th>
                    <th>Delete button</th>
                </tr>
            </thead>
            <tbody>
                {params && Object.keys(params).map((param) => (
                    <tr key={param}>
                        <td className='col-alias'><div className='col-alias'>{param}</div></td>
                        <td className='col-values'>
                            <input
                                id={`param-input-${param}`}
                                type='text'
                                value={table[param] || ''}
                                placeholder='Enter asset names separated by spaces'
                                onChange={e => loaded && setTable({ ...table, [param]: e.target.value })}
                            />
                        </td>
                        <td className='col-actions'>
                            <button title='Update' onClick={() => updateParam(currentPage, fnSetCurrentPage, param)}>
                                <FontAwesomeIcon icon={faRotateRight} />
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        <ToastContainer />
    </div>
}
